import { useEffect, useState } from "react";

import { generatePath, Redirect, useParams } from "react-router-dom";

import { getSearchList } from "@/api/endpoints/searches";
import { ROUTES } from "@/routes_new";
import { SearchLight } from "@/types/Search";

export const MentionsRedirectView = () => {
  const [redirectTarget, setRedirectTarget] = useState<string>();
  const { orgUuid } = useParams<{ orgUuid: string }>();

  useEffect(() => {
    if (!orgUuid) return;
    getSearchList({ light: true }).then(({ data }): undefined => {
      if (!data) return;
      const activeSearches = (data as SearchLight[]).filter(
        (search) => !search.end_date
      );
      if (activeSearches.length > 0) {
        const search = activeSearches[0];
        setRedirectTarget(
          generatePath(ROUTES.MENTION_DETAIL_ORGID, {
            orgUuid,
            uuid: search.uuid,
          })
        );
      } else {
        setRedirectTarget(
          generatePath(ROUTES.MENTION_NEW_ORGID, {
            orgUuid,
          })
        );
      }
    });
  }, [orgUuid]);

  if (redirectTarget && orgUuid) {
    return <Redirect to={redirectTarget} />;
  }

  return null;
};
